import React, { createContext, useContext, useEffect, useState } from 'react'

import { MapEventBus } from 'modules/space_control/lib/workSpacesMap/mapEvents'

interface MapEventBusContextType {
  eventBus: MapEventBus | null
  isReady: boolean
  setReady: (ready: boolean) => void
}

const MapEventBusContext = createContext<MapEventBusContextType | null>(null)

MapEventBusContext.displayName = 'MapEventBusContext'

export const useMapEventBus = () => {
  const context = useContext(MapEventBusContext)
  if (!context) {
    throw new Error('useMapEventBus must be used within a MapEventBusProvider')
  }
  return context
}

interface MapEventBusProviderProps {
  children: React.ReactNode
}

export const MapEventBusProvider = ({ children }: MapEventBusProviderProps) => {
  const [eventBus, setEventBus] = useState<MapEventBus | null>(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const bus = new MapEventBus()
    setEventBus(bus)

    return () => {
      bus.clear()
    }
  }, [])

  if (!eventBus) {
    return null
  }

  return (
    <MapEventBusContext.Provider value={{ eventBus, isReady, setReady: setIsReady }}>
      {children}
    </MapEventBusContext.Provider>
  )
}
